import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Creatable, Spin, Toolbar } from "./index.js";
/**
 * Render the header with headline, buttons and toolbar. In this part the sticky component
 * is ensured and you do not have to worry about it.
 *
 * @param {object} props Properties
 * @param {object<key,object>} [props.toolbar.buttons] The toolbar buttons
 * @param {object} [props.toolbar.backButton] The toolbar back button. Is showed if toolbarActiveButton is set
 *
 * @returns
 */ export const Header = (param)=>{
    let { headline, creatable, isCreatableLinkDisabled, isCreatableLinkCancel, isToolbarActive, isToolbarBusy, toolbar, multiToolbar, toolbarActiveButton, isBusyHeader, checkedNodes, onCloseMultiToolbar } = param;
    const useToolbar = checkedNodes.length ? multiToolbar : toolbar;
    return(// @ts-expect-error outdated @types/react
    /*#__PURE__*/ _jsxs(Spin, {
        spinning: !!isBusyHeader,
        size: "small",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "aiot-tree-headline",
                children: [
                    headline,
                    !isCreatableLinkCancel ? Object.keys(creatable.buttons).map((key)=>/*#__PURE__*/ _jsx(Creatable, {
                            type: key,
                            ...creatable.buttons[key],
                            isCreatableLinkDisabled: isCreatableLinkDisabled
                        }, key)) : /*#__PURE__*/ _jsx(Creatable, {
                        ...creatable.backButton,
                        type: "_aio_cancel"
                    })
                ]
            }),
            (!!Object.keys(useToolbar.buttons).length || checkedNodes.length > 0) && /*#__PURE__*/ _jsx(Toolbar, {
                isToolbarActive: isToolbarActive,
                isToolbarBusy: isToolbarBusy,
                buttons: useToolbar.buttons,
                backButton: useToolbar.backButton,
                activeButton: toolbarActiveButton,
                checkedNodes: checkedNodes,
                onCloseMultiToolbar: onCloseMultiToolbar
            })
        ]
    }));
};
